import { useEffect, useState, useCallback } from "react";
import { eventosApi } from "../api/eventosApi";
import { normalizarEventosConMenus } from "../domain/menusUtil";

export function useEventosConMenus() {
    const [loading, setLoading] = useState(true);
    const [eventos, setEventos] = useState([]);
    const [error, setError] = useState("");

    const reload = useCallback(async () => {
        setLoading(true);
        setError("");
        try {
            const ev = await eventosApi.listAll();
            setEventos(normalizarEventosConMenus(ev));
        } catch (e) {
            setError(e?.message || "Error cargando datos");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        reload();
    }, [reload]);

    return { loading, eventos, error, reload };
}
